import React from "react";
import { StocksPriceChart } from "@/src/pages/StockDetails/components/StocksPriceChart";
import { useState } from "react";
import styled from "styled-components";
import { STOCK_CHART_PERIOD_LEVELS } from "../enums";
import { PeriodChips } from "@/src/components/PeriodChips";

const Cards = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2.2rem 0rem 1.2rem 0rem;
`;

export const ChartDetails = () => {
  const [periodLevel, setPeriodLevel] = useState<string>(
    STOCK_CHART_PERIOD_LEVELS.ONEMONTH
  );

  const handlePeriodSelect = (period: string) => {
    setPeriodLevel(period);
  };

  return (
    <div>
      <StocksPriceChart periodLevel={periodLevel} />
      <PeriodChips
        periodData={Object.values(STOCK_CHART_PERIOD_LEVELS)}
        onPeriodSelect={handlePeriodSelect}
      />
    </div>
  );
};
